module.exports = __webpack_public_path__ + "media/images/gallery/constellations/perseus/per_vis-88962cd169b814d50c74de7f1bd86486.jpg";